<form [formGroup]="formGroup">
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.detach-truck-and-trailer"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-string-field formControlName="swapTrailerNumber" labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-string-field>
</form>
